import check.CheckMode
import debug.ScanDebug
import unlock.KeptGift
import unlock.UnlockFlow
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

// Her unlock (T15–T17) is what the Letter's QR opens: `/#<QR secret>`.
// Hidden modes, chosen by the query (before any #fragment):
// - `?debug` opens the Scan's debug view (T12); it needs nothing from the Letter;
// - `?check#<QR secret>` opens check mode (T13): Scans try the real Puzzle wrap, without the reveal;
// - `?forget#<QR secret>` drops the gift kept on this phone (T16), then starts her unlock from the hunt.
fun main() {
    val query = window.location.search.removePrefix("?").split("&")
    val debug = "debug" in query
    val check = "check" in query
    if ("forget" in query) {
        KeptGift.forget()
        // Back to the Letter's URL, so a reload doesn't forget again.
        window.history.replaceState(null, "", window.location.pathname + window.location.hash)
    }
    document.body?.classList?.add(if (debug || check) "debug" else "unlock")
    renderComposable(rootElementId = "root") {
        when {
            check -> CheckMode()
            debug -> ScanDebug()
            else -> UnlockFlow()
        }
    }
}
